module.exports = __webpack_public_path__ + "img/arrowdown.cb2e909e.svg";